import axios from '../../../axios';
import { IndustryDTO } from '../types/IndustryDTO';

const url = '/api/industries';

export const getIndustries = () => axios.get(url);

export const createIndustry = (industry: IndustryDTO) => axios.post(url, industry);
